/**
 * Presets for the RoundingSfComponent.
 *
 * The component is self-contained (it manages its own internal signals for
 * value and sf) and does not accept params as an input. These presets capture
 * representative initial states that can be used to document the widget or
 * seed its internal state via the study-notes editor.
 */

export interface RoundingSfPresetState {
  readonly value: number;
  readonly sf: number;
}

export const ROUNDING_SF_DEFAULT: RoundingSfPresetState = {
  value: 0.004076,
  sf: 2,
};

export const ROUNDING_SF_LARGE_NUMBER: RoundingSfPresetState = {
  value: 45321,
  sf: 3,
};

export const ROUNDING_SF_SMALL_DECIMAL: RoundingSfPresetState = {
  value: 0.0008356,
  sf: 2,
};

export const ROUNDING_SF_ROUND_UP: RoundingSfPresetState = {
  value: 6.0249,
  sf: 3,
};

export const ROUNDING_SF_ONE_SF: RoundingSfPresetState = {
  value: 7482,
  sf: 1,
};

export const ROUNDING_SF_STANDARD_DECIMAL: RoundingSfPresetState = {
  value: 12.876,
  sf: 4,
};

export const ROUNDING_SF_PRESETS: Record<string, Record<string, unknown>> = {
  default: { params: ROUNDING_SF_DEFAULT },
  'large-number': { params: ROUNDING_SF_LARGE_NUMBER },
  'small-decimal': { params: ROUNDING_SF_SMALL_DECIMAL },
  'round-up': { params: ROUNDING_SF_ROUND_UP },
  'one-sf': { params: ROUNDING_SF_ONE_SF },
  'standard-decimal': { params: ROUNDING_SF_STANDARD_DECIMAL },
};
